import Vue from 'vue'
import Vuex from 'vuex'
import util from '../utils/util.js'
import { buildAiAssistantItems } from '../utils/aiAssistant.js'
import { getScaledInputHeightCss } from '../utils/layout.js'

import authority from './modules/authority.js' //首页权限管理模块
import college from './modules/college.js' //我的同事管理模块

Vue.use(Vuex)

function resolveInitialInputHeight() {
	try {
		const saved = JSON.parse(localStorage.getItem("inputHeight"));
		return getScaledInputHeightCss(saved || 130);
	} catch (e) {
		return getScaledInputHeightCss(130);
	}
}

const store = new Vuex.Store({
	state: {
		talkingList: [], //对话中
		talkedList: [], //对话过
		browserList: [], //浏览中
		leavedList: [], //已离开
		workerList: [], //我的同事
		troubleList: [], //疑似骚扰用户
		onlineList: [], //在线访客列表
		onlineOffList: [], //已离开（未结束）
		// 同事对话列表
		cstalkingList: [], //对话中
		cstalkedList: [], //对话过
		csbrowserList: [], //浏览中
		csleavedList: [], //已离开
		csworkerList: [], //我的同事
		//点击过(isCheck为true)就只标示为红点  
		//从未点击过（isCheck为null），就是黄色背景+红点（isNew为true）
		//点击过并且有新消息过来，背景闪烁isFlicker为true（isCheck为false，unread>0）
		selectedClient: null, //所选客户的聊天页(isCheck:是否点击过 )
		toLastKeyName: '', //跟踪用户的轨迹
		selectedChatList: null, //所选客户的聊天列表
		toServerChatObj: null, //已经发送出去的消息，等待服务器回应

		selectedKey: '0', //section 从1开始 
		selectedPath: '0', //index 第几行 从0开始
		keyName: '',

		//我的同事
		// lastExpandNode: null,
		parentNode: null, //父节点
		selectedNode: null, //选中的节点
		colleagueNodeList: [], //我的同事节点
		colleagueDataList: [], //我的同事节点数据
		colleagueNum: '0', //同事的数量
		showColleagueTree: false,

		//提示音的url
		newAudioUrl: util.getLocalNewUrl(), //新用户提示音
		flickerAudioUrl: util.getLocalFlickerUrl(), //新消息提示音
		zhuanQianAudioUrl: util.getLocalZhuanqianUrl(), //转潜提示音
		progressAudioUrl: util.getLocalProgressUrl(), //进度提示音
		maxLeaveNum: 0,

		isShowSession: false,
		//高级模型编辑状态
		AIstatus: "",

		newMsgColor: '',//新消息提示颜色


		newQuickFlag: false,//快捷定位贯标标志

		// 智能助手话术（WS type=2000），网页/桌面共用
		aiAssistantSuggest: {
			cid: '',
			sid: '',
			items: [],
			updatedAt: 0,
			collapsed: false,
		},

		iAutoChange: {
			'type': 0,
			'content': "",
			'message': '',
			'cid': "",
			'sid': ""
		}, //是否需要自动转微或转电

		toUpDetail: {
			'type': 0, //0-昵称 1-备注
			'content': ''
		}, //聊天页面正好在ws推过来的页面，需要实时变更相应的昵称和备注

		adapteredClient: null,

		currentTheme: util.getLocalTheme(),
		isOnline: true,
		leftBarClickObj: {
			logSelected: false,
			talkSelected: true,
			reportSelected: false,
			settingSelected: false,
			wordSelected: false,
		},
		copyText: '',
		tips: {
			code: null,
			tipsText: null
		},
		hrefData: {

		},
		fontSize: null,
		hideOlc: true,
		resetWorkListStatus: false,
		// 当前客服信息
		currentColleageInfo: null,
		// 同事视角
		colleageAngle: false,
		// 会话列表展开index
		DiaActiveNames: 1,
		allText: '',
		// 会话来信息
		haveMessage: false,
		// 记录请求失败弹窗个数
		errwinCount: 0,
		// 输入框高度（按分辨率缩放后的实际值；档位基准存 localStorage）
		inputHeight: resolveInitialInputHeight(),
		// myColleagueIsShow:null,
		
		isShowIp: true,

		isScrollMsg: true,
		
		// 进度更新通知 - 用于 websocket 向 clientItem 推送消息
		progressUpdateNotify: {
			cid: null,
			sid: null,
			timestamp: null,
			needUpdate: false
		},
		// 特殊显示关键字列表 - 从接口获取
		specialDisplayKeywords: [],
	},
	//getters 可以实时监听state值的变化，获取this.$store.getters.getName
	getters: {
		getTalkedList(state) {
			if (state.talkedList === null) {
				state.talkedList = []
			}
			console.log("getters---getTalkedList", state.talkedList);
			return state.talkedList
		},
		getTalkingList(state) {
			console.log("getters---getTalkingList", state.talkingList);
			// console.log('store getters getTalkingList talkingList = ', state.talkingList)
			if (state.talkingList === null) {
				state.talkingList = []
			}

			return state.talkingList
		},

		getBrowserList(state) {
			// console.log('store getters getBrowserList browerList = ', state.browserList)
			if (state.browserList === null) {
				state.browserList = []
			}
			return state.browserList
		},

		getLeavedList(state) {
			// console.log('store getters getLeavedList leavedList = ', state.leavedList)
			if (state.leavedList === null) {
				state.leavedList = []
			}

			return state.leavedList
		},
		csgetTalkedList(state) {
			if (state.cstalkedList === null) {
				state.cstalkedList = []
			}
			return state.cstalkedList
		},
		csgetTalkingList(state) {
			console.log("getters---getTalkingList", state.cstalkingList);
			// console.log('store getters getTalkingList talkingList = ', state.talkingList)
			if (state.cstalkingList === null) {
				state.cstalkingList = []
			}

			return state.cstalkingList
		},

		csgetBrowserList(state) {
			// console.log('store getters getBrowserList browerList = ', state.browserList)
			if (state.csbrowserList === null) {
				state.csbrowserList = []
			}
			return state.csbrowserList
		},

		csgetLeavedList(state) {
			// console.log('store getters getLeavedList leavedList = ', state.leavedList)
			if (state.csleavedList === null) {
				state.csleavedList = []
			}
			return state.csleavedList
		},

		getWorkerList(state) {
			// console.log('store getters getWorkerList workerList = ', state.workerList)
			if (state.workerList === null) {
				state.workerList = []
			}

			return state.workerList
		},

		getTroubleList(state) {
			// console.log('store getters getTroubleList troubleList = ', state.troubleList)
			if (state.troubleList === null) {
				state.troubleList = []
			}

			return state.troubleList
		},
		getOnlineList(state) {
			// console.log('store getters getOnlineList onlineList = ', state.onlineList)
			if (state.onlineList === null) {
				state.onlineList = []
			}

			return state.onlineList
		},

		getOnlineOffList(state) {
			// console.log('store getters getOnlineList onlineList = ', state.onlineList)
			if (state.onlineOffList === null) {
				state.onlineOffList = []
			}

			return state.onlineOffList
		},

		getPingTips(state) {
			return state.tips
		}
	},

	modules: {
		authority: authority,
		college: college,
	},

	//同步，修改state里面的值，结合commit，this.$store.commit('showPeople', '111')
	mutations: {
		setAiAssistantSuggest(state, data) {
			const payload = data || {}
			let items = []
			let cid = payload.cid || ''
			let sid = payload.sid || ''
			try {
				const parsed = buildAiAssistantItems(payload)
				items = parsed.items || []
				cid = parsed.cid || cid
				sid = parsed.sid || sid
			} catch (e) {
				console.error('setAiAssistantSuggest parse error', e)
			}
			state.aiAssistantSuggest = {
				cid,
				sid,
				items,
				updatedAt: Date.now(),
				collapsed: false,
			}
		},
		collapseAiAssistantSuggest(state, collapsed) {
			state.aiAssistantSuggest = {
				...state.aiAssistantSuggest,
				collapsed: !!collapsed,
			}
		},
		clearAiAssistantSuggest(state) {
			state.aiAssistantSuggest = {
				cid: '',
				sid: '',
				items: [],
				updatedAt: 0,
				collapsed: false,
			}
		},
		// 更新进度通知 - websocket 推送给 clientItem
		updateProgressNotify(state, payload) {
			state.progressUpdateNotify = {
				cid: payload.cid,
				sid: payload.sid,
				timestamp: Date.now(),
				needUpdate: true
			}
			console.log("store mutations updateProgressNotify:", state.progressUpdateNotify);
		},
		// 重置进度通知状态
		resetProgressNotify(state) {
			state.progressUpdateNotify.needUpdate = false
		},
		updateCsbrowserList(state, obj) {
			console.log("state.csbrowserList:", obj);
			const newUser = obj.data.customerSess
			newUser.canOperate = true
			state.csbrowserList.unshift(newUser)
		},
		changeColleageAngle(state, obj) {
			state.colleageAngle = obj
			console.log("state.colleageAngle:", obj);
		},
		changeHideOlc(state, obj) {
			state.hideOlc = obj
			console.log("state.hideOlc:", obj);
		},
		changeBg(state, obj) {
			state.cstalkingList = [], //对话中
				state.cstalkedList = [], //对话过
				state.csbrowserList = [], //浏览中
				state.csleavedList = [], //已离开
				state.DiaActiveNames = 1
			state.currentColleageInfo = obj

			console.log("state.currentColleageInfo:", obj);

		},
		addTalkObj(state, obj) {
			console.log('store mutations addTalkObj talkingList = ', state.talkingList.length)
			console.log('store mutations addTalkObj obj = ', obj)
			if (state.talkingList.length === 0) {
				obj.isChecked = false
				obj.isNew = true
				obj.isFlicker = true
				state.talkingList.unshift(obj)
				// state.toLastKeyName = '对话中'
			} else {
				var isHave = false
				for (var i = 0; i < state.talkingList.length; i++) {
					var talk = state.talkingList[i]
					if (talk.cid === obj.cid) {
						isHave = true
						obj.isChecked = false
						obj.isNew = true
						obj.isFlicker = true
						state.talkingList.splice(i, 1, obj)
						if (state.selectedClient != null) {
							if (state.selectedClient.cid == obj.cid) {
								let isChecked = state.selectedClient.isChecked
								let isFlicker = state.selectedClient.isFlicker
								let isNew = state.selectedClient.isNew
								state.selectedClient = obj
								state.selectedClient.isChecked = isChecked
								state.selectedClient.isFlicker = isFlicker
								state.selectedClient.isNew = isNew
							}
						}
						// console.log('addTalking list00000 = ', state.talkingList)
					}
				}
				if (isHave === false) {
					obj.isChecked = false
					obj.isNew = true
					obj.isFlicker = true
					state.talkingList.unshift(obj)
					// state.toLastKeyName = '对话中'
				}
			}
		},

		addBrowerObj(state, obj) {
			console.log('store mutations addBrowerObj browerList = ', state.browserList.length)
			console.log('store mutations addBrowerObj obj = ', obj)
			var isHave = false

			if (state.talkingList.length != 0) {
				for (let i = 0; i < state.talkingList.length; i++) {
					const talk = state.talkingList[i]
					if (talk.cid === obj.cid) {
						console.log('store mutations addBrowerObj 对话中存在 = ', obj)
						isHave = true
						state.talkingList.splice(i, 1, obj)
						if (state.selectedClient != null) {
							if (state.selectedClient.cid == obj.cid) {
								let isChecked = state.selectedClient.isChecked
								let isFlicker = state.selectedClient.isFlicker
								let isNew = state.selectedClient.isNew
								state.selectedClient = obj
								state.selectedClient.isChecked = isChecked
								state.selectedClient.isFlicker = isFlicker
								state.selectedClient.isNew = isNew
							}
						}
						return
					}
				}
			}
			console.log('store mutations addBrowerObj 浏览中存在 = ', obj)


			if (state.browserList.length === 0) {
				obj.gender = util.changeGender(obj.gender)
				obj.isChecked = false
				obj.isFlicker = false
				obj.isNew = false
				obj.canOperate = true
				state.browserList.unshift(obj)
				// state.toLastKeyName = '浏览中'

			} else {
				for (let i = 0; i < state.browserList.length; i++) {
					const brower = state.browserList[i]
					if (brower.cid === obj.cid) {
						console.log('store mutations addBrowerObj 浏览中存在 brower.cid = ', brower.cid)
						console.log('store mutations addBrowerObj 浏览中存在 obj.cid = ', obj.cid)
						isHave = true
						obj.canOperate = true
						obj.isChecked = false
						state.browserList.splice(i, 1, obj)
						if (state.selectedClient != null) {
							if (state.selectedClient.cid == obj.cid) {
								// let isChecked = state.selectedClient.isChecked
								let isFlicker = state.selectedClient.isFlicker
								let isNew = state.selectedClient.isNew
								state.selectedClient = obj
								state.selectedClient.isChecked = true
								state.selectedClient.isFlicker = isFlicker
								state.selectedClient.canOperate = false
								state.selectedClient.isNew = isNew
							}
						}
					}
				}
				console.log("store mutations addBrowerObj 添加到浏览中： ", obj, isHave)
				if (isHave === false) {
					obj.gender = util.changeGender(obj.gender)
					obj.isChecked = false
					obj.isFlicker = false
					obj.isNew = false
					obj.canOperate = true

					console.log("store mutations addBrowerObj 添加到浏览中： ", obj)
					state.browserList.unshift(obj)
					// state.toLastKeyName = '浏览中'
				}
			}
		},
		addTalkedObj(state, obj) {
			console.log('store mutations talkedList obj = ', obj)
			let isHave = false
			obj.canOperate = true
			for (let i = 0; i < state.talkedList.length; i++) {
				const talk = state.talkedList[i]
				if (talk.cid === obj.cid) {
					isHave = true
					obj.content = null
					obj.isChecked = false
					state.talkedList.splice(i, 1, obj)
					if (state.selectedClient != null) {
						if (state.selectedClient.cid == obj.cid) {
							let isChecked = state.selectedClient.isChecked
							let isFlicker = state.selectedClient.isFlicker
							let isNew = state.selectedClient.isNew
							state.selectedClient = obj
							state.selectedClient.isChecked = isChecked
							state.selectedClient.isFlicker = isFlicker
							state.selectedClient.isNew = isNew
						}
					}
					return
				}
			}
			if (!isHave) {
				obj.isChecked = false
				obj.isNew = false
				obj.isFlicker = false
				obj.hasLeaved = true
				obj.content = null
				state.talkedList.unshift(obj)
				// state.talkedList = state.talkedList.sort(
				// 	function (a, b) {
				// 		return b.last_sess_time - a.last_sess_time
				// 	}
				// )
				// state.toLastKeyName = '对话过'
				console.log('store mutations addLeaveObj leavedList11 = ', state.talkedList)
			}
		},
		addLeaveObj(state, obj) {
			console.log('store mutations addLeaveObj leaveList = ', state.leavedList.length)
			console.log('store mutations addLeaveObj obj = ', obj)
			console.log('store mutations addLeaveObj maxLeave = ', state.maxLeaveNum)
			var result = state.leavedList.some(function (item) {
				if (item.cid === obj.cid && item.sid === obj.sid) {
					console.log('store mutations addLeaveObj true item = ', item)
					var someItem = item
					someItem.isChecked = false
					someItem.isNew = false
					someItem.isFlicker = false
					someItem.hasLeaved = true
					obj.canOperate = false
					return true
				}
			})

			if (!result) {
				//30 50
				if (state.leavedList.length == state.maxLeaveNum) {
					// const lastObj = state.leavedList[state.maxLeaveNum - 1]
					state.leavedList.pop()
					// if (lastObj.status === '0') {
					// 	state.leavedList.pop()
					// } else {
					// 	return
					// }
				}

				obj.isChecked = false
				obj.isNew = false
				obj.isFlicker = false
				obj.hasLeaved = true
				obj.canOperate = false
				state.leavedList.unshift(obj)
				console.log("state.leavedList", state.leavedList)
				// state.leavedList = state.leavedList.sort(
				// 	function (a, b) {
				// 		return b.last_sess_time - a.last_sess_time
				// 	}
				// )

				// state.toLastKeyName = '已离开'

				console.log('store mutations addLeaveObj leavedList11 = ', state.leavedList)
			}
		},

		addTroubleObj(state, obj) {
			console.log('store mutations addTroubleObj troubleList = ', state.troubleList.length)
			console.log('store mutations addTroubleObj obj = ', obj)
			obj.canOperate = false
			var result = state.troubleList.some(function (item) {
				console.log('store mutations addTroubleObj item = ', item)
				if (item.cid === obj.cid && item.sid === obj.sid) {
					return true
				}
			})

			console.log('store mutations addTroubleObj result = ', result)

			if (!result) {
				state.troubleList.unshift(obj)
				state.troubleList = state.troubleList.sort(
					function (a, b) {
						return b.status - a.status
					}
				)
				// state.toLastKeyName = '疑似骚扰用户'
			}

			console.log('store mutations addTroubleObj troubleList11 = ', state.troubleList)
		},

		addChatObj(state, response) {
			console.log('store mutations addChatObj chatList = ', state.selectedChatList)
			console.log('store mutations addChatObj toServerChatObj = ', state.toServerChatObj)
			console.log('store mutations addChatObj response = ', response)
			// const account = util.getLocalAccount()
			if (response.data.reply_code === 200) {
				var msgObj = null
				if (state.toServerChatObj.data.msg.type === 'text') {
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							"text": state.toServerChatObj.data.msg.text,
							"type": state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"avar": state.toServerChatObj.data.cs_portrait,

						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1

					}
				} else if (state.toServerChatObj.data.msg.type === 'image') {
					let imgText = '<img data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: imgText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				} else if (state.toServerChatObj.data.msg.type === 'video') {
					let imgText = '<video data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: imgText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				} else if (state.toServerChatObj.data.msg.type === 'audio') {
					let audioText = '<audio data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: audioText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				}else if (state.toServerChatObj.data.msg.type === 'card') {
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 0),
						"text": {
							"text": '已经发送留资卡',
							"type": state.toServerChatObj.data.msg.type,
						},
						"mine": false,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"avar": state.toServerChatObj.data.cs_portrait,

						"type": '1', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				}

				if (state.selectedChatList === null) {
					state.selectedChatList = []
				}
				state.selectedChatList.push(msgObj)
			} else {
				var msgObjs = null
				if (state.toServerChatObj.data.msg.type === 'text') {
					msgObjs = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							"text": state.toServerChatObj.data.msg.text,
							"type": state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": true,
						"name": state.toServerChatObj.data.csname,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				} else if (state.toServerChatObj.data.msg.type === 'image') {
					let imgText = '<img data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObjs = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: imgText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": true,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				} else if (state.toServerChatObj.data.msg.type === 'video') {
					let imgText = '<video data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObjs = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: imgText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": true,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				} else if (state.toServerChatObj.data.msg.type === 'audio') {
					let audioText = '<audio data-src=' + state.toServerChatObj.data.msg.content + '>'
					msgObjs = {
						"date": util.timeStampToDate(response.timestamp, 1),
						"text": {
							text: audioText,
							type: state.toServerChatObj.data.msg.type,
						},
						"mine": true,
						"icon": true,
						"name": state.toServerChatObj.data.csname,
						"img": state.toServerChatObj.data.msg.content,
						"avar": state.toServerChatObj.data.cs_portrait,
						"type": '0', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				}else if (state.toServerChatObj.data.msg.type === 'card') {
					msgObj = {
						"date": util.timeStampToDate(response.timestamp, 0),
						"text": {
							"text": '已经发送留资卡',
							"type": state.toServerChatObj.data.msg.type,
						},
						"mine": false,
						"icon": false,
						"name": state.toServerChatObj.data.csname,
						"avar": state.toServerChatObj.data.cs_portrait,

						"type": '1', //0-客服或客户发的消息 1-系统提醒消息
						"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
						// 是否选中
						"isChecked": false,
						"id": response.data.replay_data.messageId,
						"sendStatus": 1
					}
				}
				if (state.selectedChatList === null) {
					state.selectedChatList = []
				}
				state.selectedChatList.push(msgObjs)
			}
		},

		upDateMessageState(state, { sendStatus, messageId }) {
			for (let i = (state.selectedChatList.length - 1); i > 0; i--) {
				console.log(state.selectedChatList[i].id, messageId);
				if (state.selectedChatList[i].id === messageId) {
					state.selectedChatList[i].sendStatus = sendStatus
					break;
				}
			}
		},


		addReadedStatusForMsg(state, { msgId }) {
			console.log('store mutations addReadedStatusForMsg   messageId', msgId)
			for (let i = (state.selectedChatList.length - 1); i >= 0; i--) {
				const item = state.selectedChatList[i]
				if (item.id === msgId) {
					Vue.set(item, 'status', 1)
				}
			}
		},

		addOnlineObj(state, obj) {
			console.log('store mutations addOnlineObj onlineList = ', state.onlineList.length)
			console.log('store mutations addOnlineObj obj = ', obj)
			// console.log('store mutations addOnlineObj maxLeave = ', state.maxLeaveNum)

			var result = state.onlineList.some(function (item) {
				if (item.cid === obj.cid && item.sid === obj.sid) {
					console.log('store mutations addLeaveObj true item = ', item)
					var someItem = item
					someItem.isChecked = false
					someItem.isNew = false
					someItem.isFlicker = false
					someItem.canOperate = false
					return true
				}
			})

			if (!result) {
				//30 50

				obj.isChecked = false
				obj.isNew = false
				obj.isFlicker = false
				obj.canOperate = false
				state.onlineList.unshift(obj)
				console.log("state.onlineList", state.onlineList)
				state.onlineList = state.onlineList.sort(
					function (a, b) {
						return b.last_sess_time - a.last_sess_time
					}
				)

				// state.toLastKeyName = '在线访客列表'

				console.log('store mutations addOnlineObj onlineList11 = ', state.onlineList)
			}
		},


		addOffOnlineObj(state, obj) {
			
			var result = state.onlineOffList.some(function (item) {
				if (item.cid === obj.cid && item.sid === obj.sid) {
					var someItem = item
					someItem.isChecked = false
					someItem.isNew = false
					someItem.isFlicker = false
					someItem.canOperate = false
					return true
				}
			})

			if (!result) {
			
				obj.isChecked = false
				obj.isNew = false
				obj.isFlicker = false
				obj.canOperate = false
				state.onlineOffList.unshift(obj)
				state.onlineOffList = state.onlineOffList.sort(
					function (a, b) {
						return b.last_sess_time - a.last_sess_time
					}
				)
			}
		},


		spliceTalkObj(state, obj) {
			console.log('store mutations spliceTalkObj obj = ', obj);
			if (!state.colleageAngle) {
				console.log('store mutations spliceTalkObj talklist = ', state.talkingList)
				if (state.talkingList.length === 0) {
					return
				}
				var talkingList = state.talkingList
				for (let i = 0; i < talkingList.length; i++) {
					var talk = talkingList[i]
					if (talk.cid === obj.cid && talk.sid === obj.sid) {
						state.talkingList.splice(i, 1)
						// if (state.talkedList.length > 0) {
						// 	var temp = state.talkedList.some(item2 => {
						// 		return item2.sid === talk.sid
						// 	})
						// 	if (temp) {
						// 		return
						// 	} else {
						// 		state.talkedList.unshift(talk)
						// 	}
						// } else {
						// 	state.talkedList.unshift(talk)
						// }
					}
				}
			} else {
				console.log('store mutations spliceTalkObj cstalklist = ', state.cstalkingList, obj)
				if (state.cstalkingList.length === 0) {
					return
				}
				var cstalkingList = state.cstalkingList
				for (let i = 0; i < cstalkingList.length; i++) {
					var cstalk = cstalkingList[i]
					if (cstalk.cid === obj.cid && cstalk.sid === obj.sid) {
						state.cstalkingList.splice(i, 1)
					}
				}
			}
		},

		adapterTalkObj(state, obj) {
			console.log('store mutations adapterTalkObj talklist = ', state.talkingList)
			if (state.talkingList.length === 0) {
				return
			}

			var talkingList = state.talkingList
			for (let i = 0; i < talkingList.length; i++) {
				var talk = talkingList[i]
				if (talk.cid === obj.cid && talk.sid === obj.sid) {
					state.adapteredClient = talk

					if (state.selectedClient !== null) {
						if (state.adapteredClient.cid === state.selectedClient.cid && state.adapteredClient.sid === state.selectedClient.sid) {
							state.selectedClient = null
						}
					}

					state.talkingList.splice(i, 1)
				}
			}
		},

		spliceBrowerObj(state, obj) {
			console.log('store mutations spliceBrowerObj browser = ', state.browserList)
			if (state.browserList === null) {
				return
			}

			var browserList = state.browserList
			for (let i = 0; i < browserList.length; i++) {
				var browser = browserList[i]
				if (browser.cid === obj.cid && browser.sid === obj.sid) {
					state.browserList.splice(i, 1)
				}
			}
		},

		spliceLeaveObj(state, obj) {
			console.log('store mutations spliceLeaveObj leave = ', state.leavedList)
			if (state.leavedList.length === 0) {
				return
			}

			for (let i = 0; i < state.leavedList.length; i++) {
				var leave = state.leavedList[i]
				if (leave.cid === obj.cid) {
					console.log('删除离开客户 nickname= ', leave.nickname)
					state.leavedList.splice(i, 1)
				}
			}
		},

		// spliceLeaveObj(state, obj) {
		// 	console.log('store mutations spliceLeaveObj leave = ', state.leavedList)
		// 	if (state.leavedList.length === 0) {
		// 		return
		// 	}

		// 	for (let i = 0; i < state.leavedList.length; i++) {
		// 		var leave = state.leavedList[i]
		// 		if (leave.cid === obj.cid) {
		// 			console.log('删除离开客户 nickname= ', leave.nickname)
		// 			state.leavedList.splice(i, 1)
		// 		}
		// 	}
		// },


		spliceTroubleObj(state, obj) {
			console.log('store mutations spliceTroubleObj trouble = ', state.troubleList)
			if (state.troubleList.length === 0) {
				return
			}

			var tList = state.troubleList
			for (let i = 0; i < tList.length; i++) {
				var trouble = tList[i]
				if (trouble.cid === obj.cid) {
					state.troubleList.splice(i, 1)
				}
			}
		},

		spliceOnlineData(state, obj) {
			console.log('store mutations spliceOnlineData online = ', state.onlineList)
			console.log("store mutations spliceOnlineData obj = ", obj)
			if (state.onlineList.length === 0) {
				return
			}

			var oList = state.onlineList
			for (let i = 0; i < oList.length; i++) {
				var online = oList[i]
				if (online.cid === obj.sess.cid) {
					state.onlineList.splice(i, 1)
				}
			}
		},


		spliceOffOnlineData(state, obj) {

			if (state.onlineOffList.length === 0) {
				return
			}
			var oList = state.onlineOffList
			for (let i = 0; i < oList.length; i++) {
				var online = oList[i]
				if (online.cid === obj.sess.cid) {
					state.onlineOffList.splice(i, 1)
				}
			}
		},

		chooseClient(state, obj) {
			console.log('store mutations chooseClient obj = ', obj)
			if (obj === null) {
				console.log('store mutations chooseClient 这是一个空对象 ', state.selectedClient)
				state.selectedClient.isChecked = false
				state.selectedClient.isFlicker = false
				state.selectedClient.isNew = false
			} else {
				console.log('store mutations chooseClient 这不是一个空对象 ', state.selectedClient)
				if (state.selectedClient !== null) {
					console.log("store mutations chooseClient 进入判断"); console.log(state.selectedClient.isChecked);
					if (state.selectedClient.isFlicker === true) {
						state.selectedClient.isChecked = true
						state.selectedClient.isFlicker = false
						state.selectedClient.isNew = false
					}
					if (state.selectedClient.isNew === true) {
						state.selectedClient.isChecked = true
						state.selectedClient.isNew = false
						state.selectedClient.isFlicker = false
					}
					if (state.selectedClient.isChecked === true) {
						console.log("===selectedClient:old 修改前", state.selectedClient.isChecked);
						state.selectedClient.isChecked = false
						console.log("===selectedClient:new 修改后", state.selectedClient.isChecked);
						console.log("store mutations chooseClient browserList:", state.browserList);
						state.selectedClient.isFlicker = false
						state.selectedClient.isNew = false
					}
				}
				var s = obj
				s.isChecked = true
				s.isFlicker = false
				s.isNew = false
				state.selectedClient = s
				console.log("===selectedClient:now 修改后", state.selectedClient);
				console.log("===selectedClient:now 修改后", state.selectedClient.isChecked);
			}
		},

		setKeyNameFn(state, iKey) {
			console.log('store mution setKeyNameFn iKey = ', iKey)
			console.log('store mution setKeyNameFn path = ', state.selectedPath)
			if (iKey === 1 && state.selectedPath >= 0) {
				state.keyName = '对话中'
				state.toLastKeyName = state.keyName
			} else if (iKey === 2 && state.selectedPath >= 0) {
				state.keyName = '浏览中'
				state.toLastKeyName = state.keyName
			} else if (iKey === 3 && state.selectedPath >= 0) {
				state.keyName = '对话过'
				state.toLastKeyName = state.keyName
			} else if (iKey === 4 && state.selectedPath >= 0) {
				state.keyName = '已离开'
				state.toLastKeyName = state.keyName
			}
			else if (iKey === 5 && state.selectedPath >= 0) {
				state.keyName = '我的同事'
				state.toLastKeyName = state.keyName
			} else if (iKey === 6 && state.selectedPath >= 0) {
				state.keyName = '疑似骚扰用户'
				state.toLastKeyName = state.keyName
			}
			else if (iKey === 7 && state.selectedPath >= 0) {
				state.keyName = '在线访客列表'
				state.toLastKeyName = state.keyName
			}
			else if (iKey === 8 && state.selectedPath >= 0) {
				state.keyName = '已离开（未结束）'
				state.toLastKeyName = state.keyName
			}
		},

		//我的同事 删除会话
		spliceChatFromWork(state, obj) {
			console.log('store mutation spliceChatFromWork obj = ', obj)
			console.log('store mutation spliceChatFromWork parent = ', state.parentNode)
			// const parent = state.parentNode
			// const children = parent.data.children || parent.data
			// const index = children.findIndex(d => d.id === data.id)
			// children.splice(index, 1)
			var sessionList = state.parentNode.data.chastSeesion
			console.log('store mutation spliceChatFromWork list = ', sessionList)
			for (var i = 0; i < state.parentNode.data.chastSeesion.length; i++) {
				const session = state.parentNode.data.chastSeesion[i]
				if (obj.cid === session.cid && obj.sid === session.sid) {
					console.log('session 删除成功 nickname = ', session.nickname)
					sessionList.splice(i, 1)
				}
			}
		},

		//我的同事 添加会话
		addChatToWork(state, obj) {
			console.log('store mutation addChatToWork obj = ', obj)
		},

		updateInfo(state, obj) {
			console.log('store mutation updateInfo obj = ', obj)
			const cid = obj.data.sess.cid
			const sid = obj.data.sess.sid
			const type = obj.data.type
			const content = obj.data.content
			const message = obj.data.message
			var text = content
			for (var i = 0; i < state.talkingList.length; i++) {
				var talk = state.talkingList[i]
				if (talk.cid === cid && talk.sid === sid) {
					console.log('store mutation talk = ', talk)
					if (!talk.isUpdateNike && talk.isUpdateNike != 1) {
						//1：姓名 2：电话 3：微信 4：qq 5：年龄 6:性别
						if (type === 5) {
							talk.age = content
						} else if (type === 2) {
							talk.tel = content
							util.playGetAudio()
						} else if (type === 6) {
							talk.gender = content
							text = util.changeGender(content)
						} else if (type === 3 || type === 4) {
							util.playGetAudio()
						}
					}

					state.iAutoChange = {
						'type': type,
						'content': text,
						'message': message,
						'cid': talk.cid,
						'sid': talk.sid
					}
					console.log('store mutation updateInfo iAutoChange = ', state.iAutoChange)

					// else if (type === 3){
					// 	state.iAutoChange = {
					// 		'type':type,
					// 		'content':content
					// 	}
					// 	console.log('store mutation updateInfo iAutoChange = ', state.iAutoChange)
					// }else if (type === 4){
					// 	state.iAutoChange = {
					// 		'type':type,
					// 		'content':content
					// 	}
					// 	console.log('store mutation updateInfo iAutoChange = ', state.iAutoChange)
					// }
				}
			}
		},

		updateNickname(state, obj) {
			console.log('store mutation updateNickname obj = ', obj)
			var upObj = null
			console.log('store mutation updateNickname talklist = ', state.talkingList)
			if (state.talkingList.length > 0) {
				for (var i = 0; i < state.talkingList.length; i++) {
					const talk = state.talkingList[i]
					if (talk.cid === obj.cid) {
						upObj = talk
						upObj.nickname = obj.nickname
						upObj.isUpdateNike = 1
						return
					}
				}
			}
			if (state.talkedList.length > 0) {
				for (var j = 0; j < state.talkedList.length; j++) {
					const browser = state.talkedList[j]
					if (browser.cid === obj.cid) {
						upObj = browser
						upObj.nickname = obj.nickname
						upObj.isUpdateNike = 1
						return
					}
				}
			}
			for (var m = 0; m < state.leavedList.length; m++) {
				const leave = state.leavedList[m]
				if (leave.cid === obj.cid) {
					upObj = leave
					upObj.nickname = obj.nickname
					upObj.isUpdateNike = 1
					return
				}
			}

			for (var n = 0; n < state.troubleList.length; n++) {
				const trouble = state.troubleList[n]
				if (trouble.cid === obj.cid) {
					upObj = trouble
					upObj.nickname = obj.nickname
					upObj.isUpdateNike = 1
					return
				}
			}
		},

		updateListLabel(state, obj) {
			console.log('store mutation updateListLabel obj = ', obj)
			var upObj = null
			console.log('store mutation updateListLabel talklist = ', state.talkingList)
			if (state.colleageAngle) {
				changeNickname(state.cstalkingList, state.csbrowserList, state.cstalkedList, state.csleavedList)

			} else {
				changeNickname(state.talkingList, state.browserList, state.talkedList, state.leavedList, state.troubleList)
			}
			function changeNickname(talkingList, browserList, talkedList, leavedList, troubleList) {
				for (var i = 0; i < talkingList.length; i++) {
					const talk = talkingList[i]
					if (talk.cid === obj.cid) {
						upObj = talk
						upObj.labels = obj.nickname
						state.toUpDetail.content = obj.nickname
						return
					}
				}
				for (var j = 0; j < browserList.length; j++) {
					const browser = browserList[j]
					if (browser.cid === obj.cid) {
						upObj = browser
						upObj.labels = obj.nickname
						state.toUpDetail.content = obj.nickname
						return
					}
				}
				for (let j = 0; j < talkedList.length; j++) {
					const browser = talkedList[j]
					if (browser.cid === obj.cid) {
						upObj = browser
						upObj.labels = obj.nickname
						// state.toUpDetail.content = []
						return
					}
				}
				for (var m = 0; m < leavedList.length; m++) {
					const leave = leavedList[m]
					if (leave.cid === obj.cid) {
						upObj = leave
						upObj.labels = obj.nickname
						state.toUpDetail.content = obj.nickname
						return
					}
				}
				if (troubleList) {
					for (var n = 0; n < troubleList.length; n++) {
						const trouble = troubleList[n]
						if (trouble.cid === obj.cid) {
							upObj = trouble
							upObj.labels = obj.nickname
							state.toUpDetail.content = obj.nickname
							return
						}
					}
				}
			}
		},

		updateSesStatus(state, obj) {
			console.log('store mutation updateSesStatus obj = ', obj)

			const cid = obj.data.sess.cid
			const sid = obj.data.sess.sid
			const status = obj.data.customerStatus
			for (var i = 0; i < state.talkingList.length; i++) {
				var talk = state.talkingList[i]
				if (talk.cid === cid && talk.sid === sid) {
					talk.customerStatus = status
				}
			}
		},

		upTalkingStatus(state, status) {
			// const selected = state.selectedClient
			// for (var i = 0; i < state.talkingList.length; i++) {
			// 	var talk = state.talkingList[i]
			// 	if (talk.cid === selected.cid && talk.sid === selected.sid) {
			// 		talk.status = status
			// 	}
			// }
			const selected = state.selectedClient
			var upObj = null
			for (var i = 0; i < state.talkingList.length; i++) {
				const talk = state.talkingList[i]
				if (talk.cid === selected.cid && talk.sid === selected.sid) {
					upObj = talk
					upObj.status = status
					return
				}
			}

			for (var j = 0; j < state.browserList.length; j++) {
				const browser = state.browserList[j]
				if (browser.cid === selected.cid && browser.sid === selected.sid) {
					upObj = browser
					upObj.status = status
					return
				}
			}

			for (var m = 0; m < state.leavedList.length; m++) {
				const leave = state.leavedList[m]
				if (leave.cid === selected.cid && leave.sid === selected.sid) {
					upObj = leave
					upObj.status = status
					return
				}
			}

			for (var n = 0; n < state.troubleList.length; n++) {
				const trouble = state.troubleList[n]
				if (trouble.cid === selected.cid && trouble.sid === selected.sid) {
					upObj = trouble
					upObj.status = status
					return
				}
			}
		},

		autoChangeStatus(state, status) {
			const selected = state.selectedClient
			var upObj = null
			for (var i = 0; i < state.talkingList.length; i++) {
				const talk = state.talkingList[i]
				if (talk.cid === selected.cid && talk.sid === selected.sid) {
					upObj = talk
					upObj.status = upObj.status > status ? upObj.status : status
					return
				}
			}

			for (var j = 0; j < state.browserList.length; j++) {
				const browser = state.browserList[j]
				if (browser.cid === selected.cid && browser.sid === selected.sid) {
					upObj = browser
					upObj.status = upObj.status > status ? upObj.status : status
					return
				}
			}

			for (var m = 0; m < state.leavedList.length; m++) {
				const leave = state.leavedList[m]
				if (leave.cid === selected.cid && leave.sid === selected.sid) {
					upObj = leave
					upObj.status = upObj.status > status ? upObj.status : status
					return
				}
			}

			for (var n = 0; n < state.troubleList.length; n++) {
				const trouble = state.troubleList[n]
				if (trouble.cid === selected.cid && trouble.sid === selected.sid) {
					upObj = trouble
					upObj.status = upObj.status > status ? upObj.status : status
					return
				}
			}
		},

		upCount(state, data) {
			console.log('store mutation upCount data = ', data)
			let cid = data.data.sess.cid
			// let sid = data.data.sess.sid

			//0:客户消息，1:客服消息，2:机器人消息，3:同事代发消息
			const iFrom = data.data.msg.from

			for (var i = 0; i < state.talkingList.length; i++) {
				var talking = state.talkingList[i]
				if (talking.cid === cid) {
					if (iFrom === 0) {
						talking.cmcount = talking.cmcount + 1
					} else if (iFrom === 1 || iFrom === 3) {
						talking.csmcount = talking.csmcount + 1
					}

					return
				}
			}
			for (var j = 0; j < state.browserList.length; j++) {
				var brower = state.browserList[j]
				if (brower.cid === cid) {
					if (iFrom === 0) {
						brower.cmcount = brower.cmcount + 1
					} else if (iFrom === 1 || iFrom === 3) {
						brower.csmcount = brower.csmcount + 1
					}

					return
				}
			}
			for (var m = 0; m < state.leavedList.length; m++) {
				var leaver = state.leavedList[m]
				if (leaver.cid === cid) {
					if (iFrom === 0) {
						leaver.cmcount = leaver.cmcount + 1
					} else if (iFrom === 1 || iFrom === 3) {
						leaver.csmcount = leaver.csmcount + 1
					}

					return
				}
			}
		},

		addSysTip(state, data) {
			console.log('store mutation addSysTip data = ', data)
			const textObj = {
				"date": util.timeStampToDate(data.data.timestamp * 1000, 0),
				"text": {
					"text": data.data.content
				},
				"mine": false,
				"name": '',
				"avar": '',
				"type": '1', //0-客服或客户发的消息 1-系统提醒消息
				"color": '0', //0-正常的聊天信息 1-单消息 2-多消息
				"isChecked": false
			}

			if (state.selectedChatList === null) {
				state.selectedChatList = []
			}
			state.selectedChatList.push(textObj)
		},

		changeOnline(state, data) {
			console.log('store mutation changeOnline data = ', data)
			state.isOnline = data
		},
		changeTips(state, data) {
			console.log('store mutation changeTips data = ', data)
			state.tips = data
		},
		changefontsize(state, data) {
			console.log('store mutation changefontsize data = ', data)
			state.fontSize = data
		},
		// 关键词音频
		playKeyRadio() {
			const audioUrl = localStorage.getItem('keyAudioUrl')

			console.log("app.vue----关键词提醒音url：", audioUrl);

			if (audioUrl === null) {
				return
			}
			let audio = document.getElementById('keyAudio')//获取audiokeyAudio
			if (audio !== null && !audio.ended) {
				setTimeout(() => {
					audio.pause()
					console.log("util flicker audio pause.")
					audio.currentTime = 0
				}, 200)
				setTimeout(() => {
					// 后续操作
					let playPromise = audio.play()
					if (playPromise) {
						playPromise.then(() => {
							console.log("util playKeyRadio audio playing1.")

						}).catch((e) => {
							// 音频加载失败
							console.log("util playKeyRadio audio err = ", e)
							// Message.error('恭喜音频报错了: ', e)
						})
					}
				}, 300);
			} else {
				setTimeout(() => {
					// 后续操作
					let playPromise = audio.play()
					if (playPromise) {
						playPromise.then(() => {
							console.log("util playKeyRadio audio playing2.")

						}).catch((e) => {
							// 音频加载失败
							console.log("util playKeyRadio audio err = ", e)
							// Message.error('恭喜音频报错了: ', e)
						})
					}
				}, 300);
			}
		},
	},

	//异步，类似于mutaitions,但是是异步操作，this.$store.dispatch('getChangeName', '111')
	actions: {
		getChangeName(context, name) {
			context.commit('showPeople', name)
		},

		addTalkData(context, data) {
			console.log('store actions addTalkData data = ', data)
			context.commit('addTalkObj', data)
		},

		addBrowerData(context, data) {
			console.log('store actions addBrowerData data = ', data)
			context.commit('addBrowerObj', data)
		},
		addTalkedData(context, data) {
			console.log('store actions addTalkedData data = ', data)
			context.commit('addTalkedObj', data)
		}
		,
		addLeaveData(context, data) {
			console.log('store actions addLeaveData data = ', data)
			context.commit('addLeaveObj', data)
		},
		addOnlineData(context, data) {
			console.log('store actions addOnlineData data = ', data)
			context.commit('addOnlineObj', data)
		},

		addOffOnlineData(context, data) {
			console.log('store actions addOffOnlineData data = ', data)
			context.commit('addOffOnlineObj', data)
		},

		pushChatList(context, data) {
			console.log('store actions pushChatList data = ', data)
			context.commit('addChatObj', data)
		},

		removeFromTalk(context, data) {
			console.log('store actions removeFromTalk data = ', data)
			context.commit('spliceTalkObj', data)
		},

		updateListNick(context, data) {
			console.log('store actions updateListNick data = ', data)
			context.commit('updateNickname', data)
		},

		updateListLabels(context, data) {
			console.log('store actions updateListLabels data = ', data)
			context.commit('updateListLabel', data)
		},

		updateClientInfo(context, data) {
			console.log('store actions updateClientInfo data = ', data)
			context.commit('updateInfo', data)
		},

		updateSession(context, data) {
			console.log('store actions updateSession data = ', data)
			context.commit('updateSesStatus', data)
		},

		upTalkingStatus(context, istatus) {
			console.log('store actions upTalkingStatus status = ', istatus)
			context.commit('upTalkingStatus', istatus)
		},

		autoChangeStatus(context, istatus) {
			console.log('store actions autoChangeStatus status = ', istatus)
			context.commit('autoChangeStatus', istatus)
		},

		updateCount(context, data) {
			console.log('store actions updateCount data = ', data)
			context.commit('upCount', data)
		},

		addSystemTip(context, data) {
			console.log('store actions addSystemTip data = ', data)
			context.commit('addSysTip', data)
		},
		changeOnlineStatus(context, data) {
			console.log("store actions changeOnlineStatu data = ", data)
			context.commit("changeOnline", data)
		},
		// 修改重连时的tips提示
		changePingTips(context, data) {
			console.log("store actions changePingTips data = ", data)
			context.commit("changeTips", data)
		},
		changeFontSize(context, data) {
			console.log("store actions changeFontSize data = ", data)
			context.commit("changefontsize", data)
		},
		playKeyRadio_(context) {
			context.commit("playKeyRadio")
		}

	}
})

export default store
